<template>
<v-card flat>
  <!-- <v-card-title >
    <v-btn @click='productType="simple"' outline small >Simple</v-btn>
    <v-btn @click='productType="advanced"' outline small >Advanced</v-btn>
  </v-card-title> -->
  <crud-table v-if='data' flat
    @add='addProduct'
    @edit='editProduct'
    @delete='deleteProduct'
    :headers='data.headers'
    :deleteable='true'
    :items='data.data'
    :loading='getProductsRequest.loading'
    no-data-text='No products found for this appointment'
    empty-btn-text='Add a product' >
  </crud-table>
  <!-- <pre v-text='data.data' /> -->
  <!-- <v-card-actions >
    <v-spacer></v-spacer>
    <v-btn color="primary" >Save</v-btn>
  </v-card-actions> -->
</v-card>
</template>

<script>
import CrudTable from '@/components/CrudTable'
import {
  ACTIVE_APPOINTMENT_DETAIL
} from '@/store/constants'

export default {
  name: 'AppointmentProduct',
  components: {
    CrudTable
  },
  props: {
    appointmentId: { type: Number }
  },
  data () {
    return {
      appointment: {},
      productType: 'simple',
      requests: {
        appointment: ACTIVE_APPOINTMENT_DETAIL,
        get: 'appointment-lineitems-get-request',
        manage: 'appointment-lineitems-manage-request'
      }
    }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler () {
        // this.loadAppointment()
        this.getLineitems()
      }
    },
    manageRequestStatus () {
      // this.loadAppointment()
      this.getLineitems()
      this.$emit('updated', this.products)
    }
  },
  methods: {
    addProduct (product) {
      product.appointment = this.appointmentId
      this.$appointmentguru
        .resource('appointment.products')
        .id(this.requests.manage)
        .create(product)
    },
    editProduct (product) {
      this.$appointmentguru
        .resource('appointment.products')
        .id(this.requests.manage)
        .save(product.id, product)
    },
    deleteProduct (product) {
      this.$appointmentguru
        .resource('appointment.products')
        .id(this.requests.manage)
        .delete(product.id)
    },
    loadAppointment () {
      if (this.appointmentId) {
        // this.appointment = {}
        this.getAppointment(this.appointmentId)
      }
    },
    getLineitems () {
      if (this.appointmentId) {
        let params = {
          appointment_id: this.appointmentId
        }
        this.$appointmentguru
          .resource('appointment.products')
          .id(this.requests.get)
          .list(params)
      }
    }
  },
  computed: {
    getProductsRequest () {
      return this.$store.getters.getRequestById(this.requests.get, true)
    },
    products () {
      return this.getObjectPath(this.getProductsRequest, 'result.data', [])
    },
    appointmentRequest () {
      return this.$store.getters.getRequestById(this.requests.appointment, true)
    },
    appointmentRequestStatus () {
      return this.appointmentRequest.status
    },
    manageRequest () {
      return this.$store.getters.getRequestById(this.requests.manage, true)
    },
    manageRequestStatus () {
      return this.manageRequest.status
    },
    data () {
      let headers = [
        {text: 'Quantity', value: 'quantity', type: 'number', required: false},
        {text: 'Description', value: 'description', required: false},
        {text: 'Price', value: 'unit_price', required: true, type: 'number'}
      ]
      if (this.productType === 'advanced') {
        headers.push({text: 'NAPPI', value: 'nappi', required: false})
        headers.push({text: 'ICD-10 Code', value: 'icd10', required: false})
        headers.push({text: 'Process Code', value: 'process', required: false})
      }
      let table = {
        headers: headers,
        data: this.products
      }
      return table
    }
  },
  i18n: {
    messages: {
      en: {
        noresults: ''
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppointmentProduct.vue?0a66319b